import api from './api';

// Tüm dinamik sayfaları menü API'sinden getir
export const getDynamicPages = async () => {
  try {
    const response = await api.get('/api/Menu/GetMenuList');
    console.log('Menü API yanıtı:', response); // API yanıtını kontrol et

    // Sadece dynamicPage true olan menüleri filtrele ve sayfa formatına dönüştür
    const dynamicPages = response.data
      .filter(menu => menu.dynamicPage === true)
      .map(menu => ({
        guid: menu.guid,
        title: menu.name,
        url: menu.code,
        content: menu.html || '',
        isActive: true,
        isDynamicPage: true,
        createdDate: menu.createdDate,
        updatedDate: menu.updatedDate
      }));

    console.log('Dönüştürülmüş dinamik sayfalar:', dynamicPages);
    return dynamicPages;
  } catch (error) {
    console.error('Error fetching dynamic pages:', error);
    throw error;
  }
};

// Tüm sayfaları getir (artık menü API'sinden)
export const getPages = async () => {
  try {
    const response = await api.get('/api/Menu/GetMenuList');
    console.log('Menü API yanıtı:', response);

    // Sadece dinamik sayfaları filtrele ve sayfa formatına dönüştür
    const pages = response.data
      .filter(menu => menu.dynamicPage === true)
      .map(menu => ({
        guid: menu.guid,
        title: menu.name,
        url: menu.code,
        content: menu.html || '',
        isActive: true,
        isDynamicPage: true,
        createdDate: menu.createdDate,
        updatedDate: menu.updatedDate
      }));

    console.log('Dönüştürülmüş sayfalar:', pages);
    return { pages }; // PageList bileşeninin beklediği format
  } catch (error) {
    console.error('Error fetching pages:', error);
    throw error;
  }
};

export const getPageById = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await api.get(`/api/Page/GetPage/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    console.log('Page details response:', response);
    return response.data;
  } catch (error) {
    console.error('Error fetching page details:', error);
    throw error;
  }
};

export const addPage = async (pageData) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    // Validate required fields
    const requiredFields = ['title', 'url', 'content'];
    const missingFields = requiredFields.filter(field => !pageData[field]);
    if (missingFields.length > 0) {
      throw new Error(`Missing required fields: ${missingFields.join(', ')}`);
    }

    const payload = {
      title: pageData.title,
      url: pageData.url,
      content: pageData.content,
      isActive: pageData.isActive !== undefined ? pageData.isActive : true,
      createdDate: new Date().toISOString()
    };

    console.log('Sending page data:', payload);

    const response = await api.post('/api/Page/AddPage', payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    console.log('Page added successfully:', response);
    return response.data;
  } catch (error) {
    console.error('Error adding page:', error);
    throw error;
  }
};

// Dinamik sayfa HTML içeriğini güncelle
export const updateDynamicPageHtml = async (menuId, html) => {
  try {
    const payload = {
      guid: menuId,
      html: html
    };

    const response = await api.post('/api/Menu/UpdateMenu', payload);
    return response.data;
  } catch (error) {
    console.error('Error updating dynamic page HTML:', error);
    throw error;
  }
};

// Normal sayfa güncelleme
export const updatePage = async (pageData) => {
  try {
    // Validate required fields
    const requiredFields = ['guid', 'title', 'url', 'content'];
    const missingFields = requiredFields.filter(field => !pageData[field]);
    if (missingFields.length > 0) {
      throw new Error(`Missing required fields: ${missingFields.join(', ')}`);
    }

    const payload = {
      guid: pageData.guid,
      title: pageData.title,
      url: pageData.url,
      content: pageData.content,
      isActive: pageData.isActive !== undefined ? pageData.isActive : true,
      updatedDate: new Date().toISOString()
    };

    console.log('Updating page data:', payload);

    const response = await api.post('/api/Page/UpdatePage', payload);
    console.log('Page updated successfully:', response);
    return response.data;
  } catch (error) {
    console.error('Error updating page:', error);
    throw error;
  }
};

export const deletePage = async (guid) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    const response = await api.post(`/api/Page/DeletePage`, {
      guid: guid
    }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    console.log('Page deleted successfully:', guid);
    // Ensure we return a value that the UI can properly interpret as success
    if (response.data === true || response.data === 'true') {
      return { isSuccess: true };
    }
    return response.data;
  } catch (error) {
    console.error('Error deleting page:', error);
    throw error;
  }
};
